// ─── Image reveal ────────────────────────────────────────────────────────────
(function () {
  var els = document.querySelectorAll('.dn-img-reveal');
  if (!els.length) return;

  var observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      setTimeout(function () {
        entry.target.classList.remove('dn-img-reveal');
      }, 500);
      entry.target.classList.add('dn-img-revealed');
      obs.unobserve(entry.target);
    });
  }, { rootMargin: '20px 0px 0px 0px' });

  els.forEach(function (el) { observer.observe(el); });
})();

// ─── GSAP scroll + load animations ───────────────────────────────────────────
(function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  var isDesktop = window.innerWidth > 991;

  // On page load: hero content fades + slides up immediately
  var loadItems = document.querySelectorAll('.dn-anim-load');
  if (loadItems.length) {
    gsap.set(loadItems, { y: 40, autoAlpha: 0 });
    gsap.to(loadItems, {
      delay: 0.3,
      duration: 0.7,
      autoAlpha: 1,
      y: 0,
      ease: 'power1.inOut',
      stagger: 0.15
    });
  }

  // On scroll: fade + slide up
  var upItems = document.querySelectorAll('.dn-anim-up');
  if (upItems.length) {
    gsap.set(upItems, { y: isDesktop ? 60 : 30, autoAlpha: 0 });
    ScrollTrigger.batch(upItems, {
      start: 'top bottom-=80',
      onEnter: function (batch) {
        batch.forEach(function (el, i) {
          gsap.to(el, {
            duration: isDesktop ? 0.8 : 0.6,
            ease: 'power1.inOut',
            y: 0,
            autoAlpha: 1,
            delay: 0.1 * i
          });
        });
      },
      once: true
    });
  }

  // On scroll: fade only (no y-translate)
  var fadeItems = document.querySelectorAll('.dn-anim-fade');
  if (fadeItems.length) {
    gsap.set(fadeItems, { autoAlpha: 0 });
    ScrollTrigger.batch(fadeItems, {
      start: 'top bottom-=80',
      onEnter: function (batch) {
        batch.forEach(function (el, i) {
          gsap.to(el, { duration: isDesktop ? 0.8 : 0.6, ease: 'power1.inOut', autoAlpha: 1, delay: 0.1 * i });
        });
      },
      once: true
    });
  }

  // On scroll: fade + slide from right
  var rightItems = document.querySelectorAll('.dn-anim-right');
  if (rightItems.length) {
    gsap.set(rightItems, { x: '12%', autoAlpha: 0 });
    ScrollTrigger.batch(rightItems, {
      start: 'top bottom-=80',
      onEnter: function (batch) {
        batch.forEach(function (el, i) {
          gsap.to(el, {
            duration: isDesktop ? 0.9 : 0.7,
            ease: 'power1.inOut',
            x: 0,
            autoAlpha: 1,
            delay: 0.1 * i
          });
        });
      },
      once: true
    });
  }
})();
